export const CUSTOMER_RECORD_ROLES = [
  "customer-service",
  "finance-department",
  "finance-audit",
  "finance-audits",
  "super",
];

export const CUSTOMER_SERVICE_ROLES = ["customer-service"];

export const FLEET_ROLES = ["operational", "super"];

const AREA_ROLE_REQUIREMENTS = {
  customers: CUSTOMER_RECORD_ROLES,
  finance: ["finance-department"],
  fleet: FLEET_ROLES,
  admin: ["super"],
};

export const canAccessNavigationArea = (areaKey, authStore) => {
  const requiredRoles = AREA_ROLE_REQUIREMENTS[areaKey];

  if (!requiredRoles) {
    return true;
  }

  return authStore?.hasAnyRole?.(requiredRoles) ?? false;
};
